
import trackerClass from './trackerClass';

trackerClass.setupTimeSince();

let update_timer = null;
function updateData() {

    console.debug('trackers: update');

    clearTimeout(update_timer);

    fetch(`/api/data/${data_path}.json?no_locations`).then((res) => {
        if (res.status === 403) {
            location.href = '/login';
        }
        return res.json()
    }).then(updateTrackers).catch(err => {
        throw err;
    });

    // triggerUpdateData();
}

function updateTrackers(json) {
    Object.keys(json.trackers).forEach((tracker_uuid) => {
        let tracker = json.trackers[tracker_uuid];
        updateTrackerStatus(tracker_uuid, tracker.info);
    });
}

function updateTrackerStatus(tracker_uuid, status) {

    if(!status || status.updated_at  <  trackers[tracker_uuid].updated_at) {
        return;
    }

    Object.keys(status).forEach((key) => {
        trackers[tracker_uuid][key] = status[key];
    });

    trackerClass.updateTracker(tracker_uuid, status);
}


import myMqtt from './myMqtt';
if(typeof mqtt_user !== 'undefined') {
    myMqtt.connect();
}

myMqtt.client.on("connect", () => {
    Object.keys(trackers).forEach((tracker_uuid) => {
        myMqtt.client.subscribe(`${site_prefix}/trackers/${tracker_uuid}/status`, (err) => {
            if (err) {
                // update_interval = update_interval_fetch;
                // updateData();
            }
        });
    });
});

myMqtt.client.on("message", (topic, message) => {
    let msg = JSON.parse(message.toString());
    if (topic.endsWith('/status')) {
        let tracker_uuid = msg.tracker_uuid;
        updateTrackerStatus(tracker_uuid, msg);
    }
});

updateData();

